import { createAction } from '@reduxjs/toolkit';

import types from './types';

const resetTestDetails = createAction(types.RESET_TEST_DETAILS);

export default {
  resetTestDetails,
};
